<template>
  <div>
    <a @click="fnShowModal()" class="p-2"
      ><i class="far fa-edit text-primary"></i
    ></a>

    <b-modal ref="modal" size="xl" hide-footer title="Employer - update">
      <div class="d-block">
        <form>
          <div class="row">
            <!-- Company 1 -->
            <div class="col-12 col-md-3 col-lg-3">
              <p class="fw-600 fs-100 text-info mb-1">Company Information</p>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  v-model="legal_name"
                />
                <label class="floatingLabel" for="legal_name"
                  >Company legal name</label
                >
                <div class="invalid-feedback" v-if="errors.legal_name">
                  {{ errors.legal_name[0] }}
                </div>
              </div>

              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  v-model="trading_as_name"
                />
                <label class="floatingLabel" for="trading_as_name"
                  >Trading as</label
                >
              </div>

              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  v-model="abn"
                />
                <label class="floatingLabel" for="name">ABN</label>
              </div>

              <div class="form-group">
                <b-form-select
                  plain
                  :options="optionFbtStatus"
                  value-field="item"
                  text-field="name"
                  placeholder=" "
                  autocomplete="off_state"
                  v-model="fbt_status"
                ></b-form-select>
                <label class="floatingLabel" for="state"
                  >Company FBT Status</label
                >
              </div>

              <p class="fw-600 fs-100 text-info mb-1">Address</p>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_address_unit_number"
                  v-model="address_unit_number"
                />
                <label class="floatingLabel" for="street">Unit number</label>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_address_street_name"
                  v-model="address_street_name"
                />
                <label class="floatingLabel" for="address_street_name"
                  >Street name</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_address_suburb"
                  v-model="address_suburb"
                />
                <label class="floatingLabel" for="address_suburb">Suburb</label>
              </div>
              <div class="form-group">
                <b-form-select
                  plain
                  :options="optionStates"
                  value-field="item"
                  text-field="name"
                  placeholder=" "
                  autocomplete="off_address_state"
                  v-model="address_state"
                ></b-form-select>
                <label class="floatingLabel" for="state">State</label>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_address_postcode"
                  v-model="address_postcode"
                />
                <label class="floatingLabel" for="address_postcode"
                  >Post code</label
                >
              </div>

              <b-form-checkbox
                class="ml1500"
                switch
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
              >
                Status
              </b-form-checkbox>
            </div>
            <!-- Company 2 -->
            <div class="col-12 col-md-3 col-lg-3">
              <p class="fw-600 fs-100 text-info mb-1">Postal address</p>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_post_address_unit_number"
                  v-model="post_address_unit_number"
                />
                <label class="floatingLabel" for="street">Unit number</label>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_post_address_street_name"
                  v-model="post_address_street_name"
                />
                <label class="floatingLabel" for="post_address_street_name"
                  >Street name</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_post_address_suburb"
                  v-model="post_address_suburb"
                />
                <label class="floatingLabel" for="post_address_suburb"
                  >Suburb</label
                >
              </div>
              <div class="form-group">
                <b-form-select
                  plain
                  :options="optionStates"
                  value-field="item"
                  text-field="name"
                  placeholder=" "
                  autocomplete="off_post_address_state"
                  v-model="post_address_state"
                ></b-form-select>
                <label class="floatingLabel" for="state">State</label>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_post_address_postcode"
                  v-model="post_address_postcode"
                />
                <label class="floatingLabel" for="post_address_postcode"
                  >Post code</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_main_phone"
                  v-model="main_phone"
                />
                <label class="floatingLabel" for="main_phone">Main Phone</label>
              </div>
              <p class="fw-600 fs-100 text-info mb-1">Bank Information</p>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_bank_bsb"
                  v-model="bank_bsb"
                />
                <label class="floatingLabel" for="bank_bsb">BSB</label>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_bank_account_number"
                  v-model="bank_account_number"
                />
                <label class="floatingLabel" for="bank_account_number"
                  >Account number</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_bank_account_name"
                  v-model="bank_account_name"
                />
                <label class="floatingLabel" for="bank_account_name"
                  >Account name</label
                >
              </div>
            </div>

            <!-- Accounts Department Contact -->
            <div class="col-12 col-md-3 col-lg-3">
              <p class="fw-600 fs-100 text-info mb-1">
                Accounts Department Contact
              </p>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_acc_contact_first_name"
                  v-model="acc_contact_first_name"
                />
                <label class="floatingLabel" for="acc_contact_first_name"
                  >First name</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_acc_contact_last_name"
                  v-model="acc_contact_last_name"
                />
                <label class="floatingLabel" for="acc_contact_last_name"
                  >Last name</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_acc_contact_position"
                  v-model="acc_contact_position"
                />
                <label class="floatingLabel" for="acc_contact_position"
                  >Position</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_acc_contact_email"
                  v-model="acc_contact_email"
                />
                <label class="floatingLabel" for="acc_contact_email"
                  >Email</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_acc_contact_phone"
                  v-model="acc_contact_phone"
                />
                <label class="floatingLabel" for="acc_contact_phone"
                  >Phone</label
                >
              </div>
              <!-- Payroll Department Contact -->
              <p class="fw-600 fs-100 text-info mb-1">
                Payroll Department Contact
              </p>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_pay_contact_first_name"
                  v-model="pay_contact_first_name"
                />
                <label class="floatingLabel" for="pay_contact_first_name"
                  >First name</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_pay_contact_last_name"
                  v-model="pay_contact_last_name"
                />
                <label class="floatingLabel" for="pay_contact_last_name"
                  >Last name</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_pay_contact_position"
                  v-model="pay_contact_position"
                />
                <label class="floatingLabel" for="pay_contact_position"
                  >Position</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_pay_contact_email"
                  v-model="pay_contact_email"
                />
                <label class="floatingLabel" for="pay_contact_email"
                  >Email</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_pay_contact_phone"
                  v-model="pay_contact_phone"
                />
                <label class="floatingLabel" for="pay_contact_phone"
                  >Phone</label
                >
              </div>

              <!-- EOY FBT Reporting -->
              <p class="fw-600 fs-100 text-info mb-1">EOY FBT Reporting</p>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_eoy_fbt_reporting_email"
                  v-model="eoy_fbt_reporting_email"
                />
                <label class="floatingLabel" for="eoy_fbt_reporting_email"
                  >Contact Email
                </label>
              </div>
            </div>

            <!-- Marketing Department Contact -->
            <div class="col-12 col-md-3 col-lg-3">
              <!-- Marketing Department Contact -->
              <p class="fw-600 fs-100 text-info mb-1">
                Marketing Department Contact
              </p>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_mar_contact_first_name"
                  v-model="mar_contact_first_name"
                />
                <label class="floatingLabel" for="mar_contact_first_name"
                  >First name</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_mar_contact_last_name"
                  v-model="mar_contact_last_name"
                />
                <label class="floatingLabel" for="mar_contact_last_name"
                  >Last name</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_mar_contact_position"
                  v-model="mar_contact_position"
                />
                <label class="floatingLabel" for="mar_contact_position"
                  >Position</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_mar_contact_email"
                  v-model="mar_contact_email"
                />
                <label class="floatingLabel" for="mar_contact_email"
                  >Email</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_mar_contact_phone"
                  v-model="mar_contact_phone"
                />
                <label class="floatingLabel" for="mar_contact_phone"
                  >Phone</label
                >
              </div>

              <!-- Pay Cycle -->
              <p class="fw-600 fs-100 text-info mb-1">Pay Cycle Information</p>
              <b-form-group label="Pay cycle">
                <b-form-checkbox-group
                  id="checkbox-group-1"
                  v-model="pay_cycle"
                  :options="optionsPayCycle"
                  value-field="item"
                  text-field="name"
                  name="flavour-1"
                ></b-form-checkbox-group>
              </b-form-group>

              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_pay_day"
                  v-model="pay_day"
                />
                <label class="floatingLabel" for="pay_day">Pay day</label>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_pay_date"
                  v-model="pay_date"
                />
                <label class="floatingLabel" for="pay_date">Pay date</label>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_pay_date_of_first_period_end"
                  v-model="pay_date_of_first_period_end"
                />
                <label class="floatingLabel" for="pay_date_of_first_period_end"
                  >Pay date of first period end</label
                >
              </div>

              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_pay_date_of_first_pay_day"
                  v-model="pay_date_of_first_pay_day"
                />
                <label class="floatingLabel" for="pay_date_of_first_pay_day"
                  >Pay date of first pay day</label
                >
              </div>

              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_pay_email_for_tax_invoice"
                  v-model="pay_email_for_tax_invoice"
                />
                <label class="floatingLabel" for="pay_email_for_tax_invoice"
                  >Pay email for tax invoice</label
                >
              </div>

              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_number_of_employee"
                  v-model="number_of_employee"
                />
                <label class="floatingLabel" for="number_of_employee"
                  >Number of employee</label
                >
              </div>
            </div>
          </div>

          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button
              type="button"
              @click="fnUpdate()"
              class="btn btn-success btn-sm"
            >
              <b-spinner v-if="isSpinner" small class="mr-2"></b-spinner>Update
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { serialize } from 'object-to-formdata'
import * as messageService from '../../services/message.service'
import * as employerService from '../../services/employer.service'
import {
  optionStates,
  optionsPayCycle,
  optionFbtStatus
} from '../../services/data.service'
export default {
  name: 'ModalReferralPartnerEdit',
  props: ['propsData'],
  components: {},
  data() {
    return {
      errors: {},
      id: '',
      legal_name: '',
      trading_as_name: '',
      abn: '',
      fbt_status: '',
      address_unit_number: '',
      address_street_name: '',
      address_suburb: '',
      address_state: '',
      address_postcode: '',
      post_address_unit_number: '',
      post_address_street_name: '',
      post_address_suburb: '',
      post_address_state: '',
      post_address_postcode: '',
      main_phone: '',
      bank_bsb: '',
      bank_account_number: '',
      bank_account_name: '',
      acc_contact_first_name: '',
      acc_contact_last_name: '',
      acc_contact_position: '',
      acc_contact_email: '',
      acc_contact_phone: '',
      pay_contact_first_name: '',
      pay_contact_last_name: '',
      pay_contact_position: '',
      pay_contact_email: '',
      pay_contact_phone: '',
      eoy_fbt_reporting_email: '',
      mar_contact_first_name: '',
      mar_contact_last_name: '',
      mar_contact_position: '',
      mar_contact_email: '',
      mar_contact_phone: '',
      pay_cycle: [],
      pay_day: '',
      pay_date: '',
      pay_date_of_first_period_end: '',
      pay_date_of_first_pay_day: '',
      pay_email_for_tax_invoice: '',
      number_of_employee: 0,
      status: '',
      isSpinner: false,
      optionStates: optionStates,
      optionsPayCycle: optionsPayCycle,
      optionFbtStatus: optionFbtStatus
    }
  },
  computed: {
    ...mapGetters(['getEmployerPaginateData', 'getEmployerPaginate'])
  },
  methods: {
    ...mapActions(['fetchEmployerPaginate']),
    fnShowModal() {
      this.fnGetValue(this.propsData)
      this.showModal()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    },

    fnGetValue(props) {
      this.id = props.id
      this.legal_name = props.legal_name
      this.trading_as_name = props.trading_as_name
      this.abn = props.abn
      this.fbt_status = props.fbt_status
      this.address_unit_number = props.address_unit_number
      this.address_street_name = props.address_street_name
      this.address_suburb = props.address_suburb
      this.address_state = props.address_state
      this.address_postcode = props.address_postcode
      this.post_address_unit_number = props.post_address_unit_number
      this.post_address_street_name = props.post_address_street_name
      this.post_address_suburb = props.post_address_suburb
      this.post_address_state = props.post_address_state
      this.post_address_postcode = props.post_address_postcode
      this.main_phone = props.main_phone
      this.bank_bsb = props.bank_bsb
      this.bank_account_number = props.bank_account_number
      this.bank_account_name = props.bank_account_name
      this.acc_contact_first_name = props.acc_contact_first_name
      this.acc_contact_last_name = props.acc_contact_last_name
      this.acc_contact_position = props.acc_contact_position
      this.acc_contact_email = props.acc_contact_email
      this.acc_contact_phone = props.acc_contact_phone
      this.pay_contact_first_name = props.pay_contact_first_name
      this.pay_contact_last_name = props.pay_contact_last_name
      this.pay_contact_position = props.pay_contact_position
      this.pay_contact_email = props.pay_contact_email
      this.pay_contact_phone = props.pay_contact_phone
      this.eoy_fbt_reporting_email = props.eoy_fbt_reporting_email
      this.mar_contact_first_name = props.mar_contact_first_name
      this.mar_contact_last_name = props.mar_contact_last_name
      this.mar_contact_position = props.mar_contact_position
      this.mar_contact_email = props.mar_contact_email
      this.mar_contact_phone = props.mar_contact_phone
      this.pay_cycle = props.pay_cycle
      this.pay_day = props.pay_day
      this.pay_date = props.pay_date
      this.pay_date_of_first_period_end = props.pay_date_of_first_period_end
      this.pay_date_of_first_pay_day = props.pay_date_of_first_pay_day
      this.pay_email_for_tax_invoice = props.pay_email_for_tax_invoice
      this.number_of_employee = props.number_of_employee
      this.status = props.status
    },

    fnUpdate: async function () {
      this.isSpinner = true

      let obj = {
        id: this.id,
        legal_name: this.legal_name,
        trading_as_name: this.trading_as_name,
        abn: this.abn,
        fbt_status: this.fbt_status,
        address_unit_number: this.address_unit_number,
        address_street_name: this.address_street_name,
        address_suburb: this.address_suburb,
        address_state: this.address_state,
        address_postcode: this.address_postcode,
        post_address_unit_number: this.post_address_unit_number,
        post_address_street_name: this.post_address_street_name,
        post_address_suburb: this.post_address_suburb,
        post_address_state: this.post_address_state,
        post_address_postcode: this.post_address_postcode,
        main_phone: this.main_phone,
        bank_bsb: this.bank_bsb,
        bank_account_number: this.bank_account_number,
        bank_account_name: this.bank_account_name,
        acc_contact_first_name: this.acc_contact_first_name,
        acc_contact_last_name: this.acc_contact_last_name,
        acc_contact_position: this.acc_contact_position,
        acc_contact_email: this.acc_contact_email,
        acc_contact_phone: this.acc_contact_phone,
        pay_contact_first_name: this.pay_contact_first_name,
        pay_contact_last_name: this.pay_contact_last_name,
        pay_contact_position: this.pay_contact_position,
        pay_contact_email: this.pay_contact_email,
        pay_contact_phone: this.pay_contact_phone,
        eoy_fbt_reporting_email: this.eoy_fbt_reporting_email,
        mar_contact_first_name: this.mar_contact_first_name,
        mar_contact_last_name: this.mar_contact_last_name,
        mar_contact_position: this.mar_contact_position,
        mar_contact_email: this.mar_contact_email,
        mar_contact_phone: this.mar_contact_phone,
        pay_cycle: this.pay_cycle,
        pay_day: this.pay_day,
        pay_date: this.pay_date,
        pay_date_of_first_period_end: this.pay_date_of_first_period_end,
        pay_date_of_first_pay_day: this.pay_date_of_first_pay_day,
        pay_email_for_tax_invoice: this.pay_email_for_tax_invoice,
        number_of_employee: this.number_of_employee,
        status: this.status
      }

      const options = {
        /**
         * include array indices in FormData keys
         * defaults to false
         */
        indices: true,

        /**
         * treat null values like undefined values and ignore them
         * defaults to false
         */
        nullsAsUndefineds: false,

        /**
         * convert true or false to 1 or 0 respectively
         * defaults to false
         */
        booleansAsIntegers: false,

        /**
         * store arrays even if they're empty
         * defaults to false
         */
        allowEmptyArrays: true,

        /**
         * don't include array notation in FormData keys for Files in arrays
         * defaults to false
         */
        noFilesWithArrayNotation: true,

        /**
         * use dots instead of brackets for object notation in FormData keys
         * defaults to false
         */
        dotsForObjectNotation: false
      }

      const formSerializeData = serialize(
        obj,
        options // optional
        // existingFormData, // optional
        // keyPrefix // optional
      )

      try {
        const response = await employerService.update(
          this.id,
          formSerializeData
        )

        this.fetchEmployerPaginate(this.getEmployerPaginate)
        this.hideModal()

        messageService.fnSweetAlertSuccessToast(
          'Employer',
          'Updated successfully '
        )
        this.legal_name = ''
        this.trading_as_name = ''
        this.abn = ''
        this.fbt_status = ''
        this.address_unit_number = ''
        this.address_street_name = ''
        this.address_suburb = ''
        this.address_state = ''
        this.address_postcode = ''
        this.post_address_unit_number = ''
        this.post_address_street_name = ''
        this.post_address_suburb = ''
        this.post_address_state = ''
        this.post_address_postcode = ''
        this.main_phone = ''
        this.bank_bsb = ''
        this.bank_account_number = ''
        this.bank_account_name = ''
        this.acc_contact_first_name = ''
        this.acc_contact_last_name = ''
        this.acc_contact_position = ''
        this.acc_contact_email = ''
        this.acc_contact_phone = ''
        this.pay_contact_first_name = ''
        this.pay_contact_last_name = ''
        this.pay_contact_position = ''
        this.pay_contact_email = ''
        this.pay_contact_phone = ''
        this.eoy_fbt_reporting_email = ''
        this.mar_contact_first_name = ''
        this.mar_contact_last_name = ''
        this.mar_contact_position = ''
        this.mar_contact_email = ''
        this.mar_contact_phone = ''
        this.pay_cycle = []
        this.pay_day = ''
        this.pay_date = ''
        this.pay_date_of_first_period_end = ''
        this.pay_date_of_first_pay_day = ''
        this.pay_email_for_tax_invoice = ''
        this.number_of_employee = 0
        this.isSpinner = false
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Employer - Edit',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Employer - Edit',
              'Something wrong'
            )
            break
        }
        this.isSpinner = false
      }
    }
  }
}
</script>
